<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.658"
    height="27"
    viewBox="-3 -2 24 31"
    fill="none"
  >
    <path
      id="Path_8595"
      data-name="Path 8595"
      d="M16.376,3.376a9.34,9.34,0,0,0-9.329,9.33c0,5.186,4.781,12.107,8.793,17l.549.671.778-1c2.555-3.263,8.538-10.9,8.538-16.675A9.34,9.34,0,0,0,16.376,3.376Zm-3.347,9.676a3.345,3.345,0,1,1,3.347,3.378A3.365,3.365,0,0,1,13.029,13.052Z"
      transform="translate(-7.047 -3.376)"
      class="st1"
    />
  </svg>
</template>

<script>
export default {
  name: 'AddPropertyIcon',
};
</script>

<style scoped lang="scss">
.st1 {
  fill: main.$npGray;
}
</style>
